export default __webpack_public_path__ + "static/media/flag-christmas-island.ef6d3ec1.svg";